import { useEffect } from 'react';

export const useOnUnmount = (action: () => void) => {
  useEffect(() => {
    return () => action();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps
};
